import React, { useEffect, useState } from "react";
import { useFirestoreQuery } from "../../../firebase/hooks";
import { firestore } from "../../../helpers/firebaseHelper";
import _ from "underscore";
import {
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LineChart,
    ResponsiveContainer
} from "recharts";
import { Box, CircularProgress } from "@material-ui/core";
import moment from "moment";

const getRandomColor = () => {
    return "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0");
};

export default function Insights(props) {
    const { livestream } = props;
    const [loading, setLoading] = useState(false);
    const [graphData, setGraphData] = useState([]);
    const livestreamsRef = firestore.collection('livestreams');
    const liveStreams = useFirestoreQuery(
        livestreamsRef.where("id", "==", livestream)
    );

    const lines = () => {
        const entries = graphData.map((option) => {
            const keys = Object.keys(option);
            return keys;
        });
        const flattened = entries.reduce((prev, current) => {
            prev = prev.concat(current);
            return prev;
        }, []);
        const filtered = flattened.filter((key) => key !== "date");
        const uniqueKeys = [...new Set(filtered)];
        return uniqueKeys.map((key) => {
            return <Line type="monotone" stroke={getRandomColor()} dataKey={key} />;
        });
    };

    useEffect(() => {
        console.log(liveStreams);

        if (liveStreams && liveStreams[0] && liveStreams[0].id) {
            let stream = liveStreams[0];
            let datum = [];

            stream.downloads && stream.downloads.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Downloads",
                })
            });

            stream.emails && stream.emails.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Emails",
                })
            })

            stream.payments && stream.payments.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Payments",
                })
            })

            stream.pollings && stream.pollings.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Pollings",
                })
            })

            stream.ratings && stream.ratings.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Ratings",
                })
            })

            stream.sharings && stream.sharings.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Sharings",
                })
            })

            stream.urls && stream.urls.forEach((x) => {
                datum.push({
                    date: moment.unix(x.createdAt).format("DD-MM-YYYY"),
                    name: "Urls",
                })
            })


            var groups = _.groupBy(datum, function (value) {
                return value.date;
            });
            
            var data = _.map(groups, function (group) {
                return {
                    date: group[0].date,
                    Downloads: _.filter(group, x => x.name === 'Downloads').length,
                    Emails: _.filter(group, x => x.name === 'Emails').length,
                    Payments: _.filter(group, x => x.name === 'Payments').length,
                    Polls: _.filter(group, x => x.name === 'Pollings').length,
                    Ratings: _.filter(group, x => x.name === 'Ratings').length,
                    Sharings: _.filter(group, x => x.name === 'Sharings').length,
                    Hyperlink: _.filter(group, x => x.name === 'Urls').length,
                }
            });

            setGraphData(data);
        }
        setLoading(!loading)
    }, [liveStreams]);


    return (
        <>
            {
                loading && <Box display={"flex"} alignItems={"center"} justifyContent={"center"} className="m-4">
                    <CircularProgress />
                </Box>
            }
            <ResponsiveContainer width="100%" height="90%">
                <LineChart

                    data={graphData}
                    margin={{
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 20
                    }}
                >
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    {lines()}
                </LineChart>
            </ResponsiveContainer>
        </>
    );
}
